module.exports = __webpack_public_path__ + "img/attack_icon.1d41e2ae.svg";